const styles = {
  cardImgWrapper: 'rounded-2 overflow-hidden relative',
  cardImg: 'w-full md:w-[350px] h-[200px]',
  cardImgCaption: 'pt-2 text-body1 text-gray-2',
  gradient:
    'opacity-0 hover:opacity-100 absolute inset-0 hover:top-0 aspect aspect-1:1 bg-gradient-to-r from-black -left-16',
};

export default styles;
